function Pagination({ table, t, showTour, selectionText = 'texts.list.selection', getRowCount }) {

  const {
    visibleColumns,
    preGlobalFilteredRows,
    // setGlobalFilter,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = table;

  const rowCount = getRowCount ? getRowCount(preGlobalFilteredRows) : preGlobalFilteredRows.length;

  return <tr>
    <th
      colSpan={visibleColumns.length}
      style={{
        textAlign: 'left',
      }}
    >
      <div id="pagination" className="pagination" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span className="pagination_buttons">
          <button className='round-button' onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            <svg width="35" height="15" viewBox="0 0 35 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ backgroundColor: "transparent" }}>
              <path fillRule="evenodd" clipRule="evenodd" d="M-8.75405e-07 7.5L12 15L12 1.96437e-07L-8.75405e-07 7.5Z" fill="white"></path>
              <path fillRule="evenodd" clipRule="evenodd" d="M16 7.5L28 15L28 1.96437e-07L16 7.5Z" fill="white"></path>
            </svg>
          </button>
          {' '}
          <button className='round-button' onClick={() => previousPage()} disabled={!canPreviousPage}>
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ backgroundColor: "transparent" }}>
              <path fillRule="evenodd" clipRule="evenodd" d="M-8.75405e-07 7.5L12 15L12 1.96437e-07L-8.75405e-07 7.5Z" fill="white"></path>
            </svg>
          </button>{' '}
          <button className='round-button' onClick={() => nextPage()} disabled={!canNextPage}>
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ backgroundColor: "transparent" }}>
              <path fillRule="evenodd" clipRule="evenodd" d="M0 7.5L12 15L12 0L0 7.5Z" fill="white" transform="rotate(180 6 7.5)"></path>
            </svg>
          </button>{' '}
          <button className='round-button' onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            <svg width="35" height="15" viewBox="0 0 35 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ backgroundColor: "transparent" }}>
              <path fillRule="evenodd" clipRule="evenodd" d="M0 7.5L12 15L12 0L0 7.5Z" fill="white" transform="rotate(180 6 7.5)"></path>
              <path fillRule="evenodd" clipRule="evenodd" d="M16 7.5L28 15L28 0L16 7.5Z" fill="white" transform="rotate(180 22 7.5)"></path>
            </svg>
          </button>{' '}
        </span>
        &nbsp;
        <span className="pagination_pages">
          {t('texts.list.page')}
          <input
            type="number"
            // defaultValue={pageIndex + 1}
            value={pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(page)
            }}
            style={{ width: '50px', textAlign: "center", fontSize: '1rem', }}
          />
          {t('texts.list.page_of', { count: pageOptions.length })}
        </span>{' '}
        &nbsp;
        <select id="pagination_perpage"
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
          style={{ fontSize: '1rem' }}
        >
          {
            [10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                {t('texts.list.page_size', { count: pageSize })}
              </option>
            ))
          }
        </select>{'  '}

        {'  '}
        {selectionText !== null &&
          <span className="pagination_currentselection">
            {t(selectionText, { count: rowCount })}
          </span>
        }
        <span className="pagination_tour">
          {showTour &&
            <div style={{ backgroundColor: "transparent" }}>
              <button className='red-button' onClick={() => showTour()}>TOUR</button>
            </div>
          }
        </span>
      </div>
    </th>
  </tr>
}

export default Pagination;